import Footer from "../components/Footer";
import Logo3D from "../components/Logo3D";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_vandys-gallery/artifacts/accmjott_vandy%27s%20logo.PNG";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="pt-20 md:pt-24 min-h-screen">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="py-10 md:py-14">
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light text-[#1A1A1A]"
            style={{ fontFamily: "'Lazy Dog', cursive" }}
          >
            about vandy's
          </h1>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-start pb-20">
          <div className="space-y-6">
            <p
              className="text-lg text-[#3a3a3a] leading-relaxed"
              style={{ fontFamily: "'Courier New', Courier, monospace" }}
            >
              vandy's was born from a love of drawing weird little animals and turning them into things you can hang on your wall, stick on your laptop, or gift to a friend.
            </p>
            <p
              className="text-base text-[#3a3a3a] leading-relaxed"
              style={{ fontFamily: "'Courier New', Courier, monospace" }}
            >
              every illustration is hand-drawn with care — from cosmic tigers to tiny chaos frogs. our collection spans art prints, stickers, stationery, accessories, and home goods.
            </p>
            <p
              className="text-base text-[#3a3a3a] leading-relaxed"
              style={{ fontFamily: "'Courier New', Courier, monospace" }}
            >
              no mass production. no algorithms deciding what we make. just hand-drawn art that makes people smile.
            </p>

            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-[#E01A23]/10">
              <div>
                <p className="text-3xl text-[#E01A23]" style={{ fontFamily: "'Lazy Dog', cursive" }}>
                  50+
                </p>
                <p className="text-xs text-[#555] mt-1" style={{ fontFamily: "'Courier New', Courier, monospace" }}>
                  original designs
                </p>
              </div>
              <div>
                <p className="text-3xl text-[#E01A23]" style={{ fontFamily: "'Lazy Dog', cursive" }}>
                  100%
                </p>
                <p className="text-xs text-[#555] mt-1" style={{ fontFamily: "'Courier New', Courier, monospace" }}>
                  hand-drawn
                </p>
              </div>
              <div>
                <p className="text-3xl text-[#E01A23]" style={{ fontFamily: "'Lazy Dog', cursive" }}>
                  6
                </p>
                <p className="text-xs text-[#555] mt-1" style={{ fontFamily: "'Courier New', Courier, monospace" }}>
                  categories
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center gap-6">
            <div className="h-[300px] md:h-[400px] w-full">
              <Logo3D />
            </div>
            <p
              className="text-sm text-[#555] italic text-center"
              style={{ fontFamily: "'Lazy Dog', cursive" }}
            >
              "art that makes you smile"
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
